import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/document/page', params)

// 删除
export const remove = id => request.get(`/masterdata-api/document/delete/${id}`)

// 新增
export const add = params =>
  request.post('/masterdata-api/document/upload', params)

// 下载
export const download = id =>
  request.get(
    `/masterdata-api/document/download/${id}`,
    {},
    { responseType: 'blob' },
  )
